<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o5FKPy/tc-custom/9781504034418.jpg?1734206953243" alt="This image is the cover for the book Sherman's March"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sherman's March
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>New York Times</i>–bestselling author’s account of the devastating military campaign that broke the Confederacy’s back in the last months of the Civil War.</b><br/><br/> In November 1864, just days after the reelection of President Abraham Lincoln, Gen. William T. Sherman vowed to “make Georgia howl.” The hero of Shiloh and his 65,000 Federal troops destroyed the great city of Atlanta, captured Savannah, and cut a wide swath of destruction through Georgia and the Carolinas on their way to Virginia. A scorched-earth campaign that continues to haunt the Southern imagination, Sherman’s “March to the Sea” and ensuing drive north was a crucial turning point in the War between the States.<br/><br/> Weaving together hundreds of eyewitness accounts, bestselling author Burke Davis tells the story of this infamous episode from the perspective of the Union soldiers and the Confederate men and women who stood in their path. Eloquent, heartrending, and vastly informative, <i>Sherman’s March</i> brilliantly examines one of the most polarizing figures in American military history and offers priceless insights into the enduring legacy of the Civil War.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Burke Davis
      </h2>
      
      <p class="authorDescription body article">Burke Davis (1913&ndash;2006) was an American author and journalist best known for his narrative histories of the Civil War, including <I>To Appomattox: Nine April Days, 1865 </I>(1959), <I>Sherman&rsquo;s March </I>(1980), and <I>The Last Surrender </I>(1985). His acclaimed biographies of military and political figures include <I>They Called Him Stonewall </I>(1954), <I>Gray Fox: Robert E. Lee and the Civil War </I>(1956), <I>Marine!: The Life of Chesty Puller </I>(1962), and <I>Old Hickory: A Life of Andrew Jackson </I>(1977). A longtime special projects writer for Colonial Williamsburg, Davis also published many works of historical nonfiction for young readers. His numerous honors include the Mayflower Cup, the North Carolina Award for Literature, and election to the North Carolina Journalism Hall of Fame and the North Carolina Literary Hall of Fame.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68c01724